<template>
    <div class="sub_contents">
        <div class="cont_center">
            <h2 class="title_page">MY PAGE</h2>
            <div class="mypage_area personal">
                <ul class="sub_link_list">
                    <li>
                        <RouterLink to="/HFO_MP_003">1:1 문의 내역</RouterLink>
                    </li>
                    <li class="on">
                        <RouterLink to="/HFO_MP_005">개인정보관리</RouterLink>
                    </li>
                </ul>

                <ul class="tab_list tab_col_4">
                    <li class="on">
                        <RouterLink to="/HFO_MP_005">회원정보 <br class="pc_none">변경</RouterLink>
                    </li>
                    <li>
                        <RouterLink to="/HFO_MP_007">마케팅정보 <br class="pc_none">수신동의</RouterLink>
                    </li>
                </ul>

                <div class="login_box_area">
                    <div class="login_input_area">
                        <ul class="login_input_list">
                            <li>
                                <h3 class="title_input">이름 <span class="required_star">*</span></h3>
                                <p class="member_name member_name_input_size">{{ decryptedLoginInfo.userName }}</p>
                            </li>
                            <li>
                                <h3 class="title_input">연락처 <span class="required_star">*</span></h3>
                                <InputText v-model="userMobile" :placeholder="placeholderMobile" id="mobile"
                                    :disabled="isMobileReadonly" :readonly="isMobileReadonly" />
                                <p class="mobile_notice">
                                    <span class="required_star">*</span> 이벤트 응모 및 혜택 정보를 위해서 정확한 연락처를 입력해주세요.
                                </p>
                            </li>
                            <li>
                                <h3 class="title_input">이메일 <span class="required_star">*</span></h3>
                                <div class="email_area_stacked">
                                    <div class="email_input_row">
                                        <InputText v-model="emailId" :placeholder="placeholderEmail" id="email1"
                                            :disabled="isEmailReadonly" :readonly="isEmailReadonly" />
                                        <span class="email_at">@</span>
                                        <InputText v-model="emailDomain" id="email2" :disabled="isEmailReadonly"
                                            :readonly="isEmailReadonly" />
                                    </div>
                                </div>
                            </li>
                            <li class="no_required">
                                <h3 class="title_input">부가정보 <span class="input_optional">(선택)</span></h3>
                                <div class="optional_info_panel">
                                    <div class="optional_info_item">
                                        <p class="optional_info_label">생년월일</p>
                                        <InputText v-model="birthInput" id="birthInput"
                                            placeholder="YYYY-MM-DD (예: 1990-01-31)"
                                            @update:modelValue="handleBirthInput" />
                                        <p class="optional_info_notice optional_info_notice_birth"><span
                                                class="required_star">*</span>숫자 8자리로 입력해 주세요.
                                        </p>
                                    </div>

                                    <div class="optional_info_item optional_info_item_gender">
                                        <p class="optional_info_label">성별</p>
                                        <div class="gender_select_area">
                                            <RadioBox v-for="option in genderOption" :key="option.id" :id="option.id"
                                                :name="radioGroupName" :value="option.value" :label="option.label"
                                                v-model="genderValues" />
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <div class="btn_login_area" style="margin-bottom: 20px;">
                            <button class="btn_type2" @click.prevent="handleJoin()">확인</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <AlertPopup v-model="alertRequiredShow" title="알림">
        <template #layer_content>
            <p class="alert_txt" id="alert_txt">
                {{ alertContent }}
            </p>
        </template>
    </AlertPopup>
</template>

<script>
import InputText from '@/components/InputText'
import RadioBox from '@/components/RadioBox'
import { putAxios, getAxiosDirect } from '@/lib/AxiosCall'
import { LOCAL_STORAGE_HVM_USERINFO } from '@/lib/Constant';
import AlertPopup from '@/components/AlertPopup.vue';
import { encryptAES256 } from '@/lib/crypto';

export default {
    components: {
        InputText,
        RadioBox,
        AlertPopup
    },
    data() {
        return {
            alertRequiredShow: false,
            alertContent: '',
            placeholderEmail: '이메일을 입력하세요.',
            placeholderMobile: '연락처를 입력하세요. (예: 010-1234-5678)',
            emailId: '',
            emailDomain: '',
            userMobile: '',
            birthInput: '',
            genderOption: [
                { id: 'M', label: '남성', value: 'M', checked: false },
                { id: 'F', label: '여성', value: 'F', checked: false },
                { id: 'NONE', label: '선택안함', value: '', checked: true }
            ],
            radioGroupName: 'gender',
            genderValues: '',
            isMobileReadonly: true,
            isEmailReadonly: false,
            decryptedLoginInfo: {
                userName: '',
                userBirth: '',
                userEmail: '',
                userMobile: '',
                userGender: '',
            }
        }
    },
    setup() {
        const loginInfo = JSON.parse(localStorage.getItem(LOCAL_STORAGE_HVM_USERINFO) || '{}');
        return { loginInfo };
    },
    mounted() {
        this.fetchUserDataFromAPI();
    },
    methods: {
        normalizePhoneNumber(phoneNumber) {
            if (!phoneNumber) return '';

            let cleanNumber = phoneNumber.replace(/\s/g, '');

            if (cleanNumber.startsWith('+82')) {
                cleanNumber = cleanNumber.substring(3);
                if (!cleanNumber.startsWith('0')) {
                    cleanNumber = '0' + cleanNumber;
                }
            }
            else if (cleanNumber.startsWith('82') && cleanNumber.length > 10) {
                cleanNumber = cleanNumber.substring(2);
                if (!cleanNumber.startsWith('0')) {
                    cleanNumber = '0' + cleanNumber;
                }
            }

            return cleanNumber;
        },

        // 화면 표시용 포맷팅 (하이픈 포함)
        formatPhoneForDisplay(phoneNumber) {
            const normalized = this.normalizePhoneNumber(phoneNumber);
            // 숫자만 추출
            const numbers = normalized.replace(/[^0-9]/g, '');

            // 하이픈 추가하여 포맷팅
            if (numbers.length === 11) {
                // 010-1234-5678 형태
                return numbers.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
            } else if (numbers.length === 10) {
                // 02-1234-5678 또는 031-123-4567 형태
                if (numbers.startsWith('02')) {
                    return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
                } else {
                    return numbers.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
                }
            }

            return normalized;
        },

        getCleanPhoneNumber(phoneNumber) {
            const normalized = this.normalizePhoneNumber(phoneNumber);
            return normalized.replace(/[^0-9]/g, '');
        },

        formatBirthForDisplay(inputValue) {
            const digitsOnly = String(inputValue || '').replace(/[^0-9]/g, '').slice(0, 8);
            if (digitsOnly.length <= 4) {
                return digitsOnly;
            }
            if (digitsOnly.length <= 6) {
                return `${digitsOnly.slice(0, 4)}-${digitsOnly.slice(4)}`;
            }
            return `${digitsOnly.slice(0, 4)}-${digitsOnly.slice(4, 6)}-${digitsOnly.slice(6, 8)}`;
        },

        handleBirthInput(inputValue) {
            this.birthInput = this.formatBirthForDisplay(inputValue);
        },

        getNormalizedBirthDate() {
            const birthDigits = String(this.birthInput || '').replace(/[^0-9]/g, '');
            if (!birthDigits) {
                return '';
            }
            if (birthDigits.length !== 8) {
                return null;
            }

            const year = Number(birthDigits.slice(0, 4));
            const month = Number(birthDigits.slice(4, 6));
            const day = Number(birthDigits.slice(6, 8));
            const currentYear = new Date().getFullYear();

            if (year < 1900 || year > currentYear || month < 1 || month > 12) {
                return null;
            }

            const maxDay = new Date(year, month, 0).getDate();
            if (day < 1 || day > maxDay) {
                return null;
            }

            return `${birthDigits.slice(0, 4)}-${birthDigits.slice(4, 6)}-${birthDigits.slice(6, 8)}`;
        },

        isValidEmail(userEmail) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail);
        },

        async fetchUserDataFromAPI() {
            try {
                const loginInfo = this.loginInfo;
                if (!loginInfo || !loginInfo.userId) {
                    throw new Error('사용자 ID가 없습니다.');
                }

                const response = await getAxiosDirect("/bgm/v1/auth/search/member", {
                    userId: loginInfo.userId
                });

                if (response) {
                    const emailValue = response.userEmail || '';
                    if (emailValue && emailValue.includes('@')) {
                        const tmpEmail = emailValue.split("@");
                        this.emailId = tmpEmail[0] || '';
                        this.emailDomain = tmpEmail[1] || '';
                    } else {
                        this.emailId = '';
                        this.emailDomain = '';
                    }
                    this.isEmailReadonly = (response.userInType || '') === 'USER_IN_KAKAO' && Boolean(this.emailId && this.emailDomain);

                    const mobileValue = response.userMobile;
                    if (mobileValue) {
                        this.userMobile = this.formatPhoneForDisplay(mobileValue);
                    } else {
                        this.userMobile = '';
                    }

                    const responseBirth = String(response.userBirth || '');
                    this.birthInput = this.formatBirthForDisplay(responseBirth);

                    const responseGender = String(response.userGender || '').toUpperCase();
                    this.genderValues = (responseGender === 'M' || responseGender === 'F') ? responseGender : '';

                    this.decryptedLoginInfo = {
                        userName: response.userName || '',
                        userBirth: response.userBirth || '',
                        userEmail: response.userEmail || '',
                        userMobile: response.userMobile || '',
                        userGender: response.userGender || '',
                    };

                } else {
                    throw new Error('사용자 정보를 불러올 수 없습니다.');
                }
            } catch (error) {
                console.error('사용자 데이터 API 호출 오류:', error);
                this.alertContent = '사용자 정보를 불러오는 중 오류가 발생했습니다.';
                this.alertRequiredShow = true;
            }
        },

        async handleJoin() {
            try {
                if (!this.userMobile || this.userMobile.trim() === '') {
                    this.alertContent = '연락처를 입력해 주세요';
                    this.alertRequiredShow = true;
                    return;
                }

                const cleanMobile = this.getCleanPhoneNumber(this.userMobile);
                if (!/^01\d{8,9}$/.test(cleanMobile)) {
                    this.alertContent = '연락처 형식이 올바르지 않습니다. (예: 010-1234-5678)';
                    this.alertRequiredShow = true;
                    return;
                }

                const userBirth = this.getNormalizedBirthDate();
                if (userBirth === null) {
                    this.alertContent = '생년월일 형식이 올바르지 않습니다. YYYY-MM-DD 형태로 입력해 주세요.';
                    this.alertRequiredShow = true;
                    return;
                }

                const emailId = (this.emailId || '').trim();
                const emailDomain = (this.emailDomain || '').trim();
                if (!emailId || !emailDomain) {
                    this.alertContent = this.isEmailReadonly
                        ? '카카오 이메일 정보를 불러오지 못했습니다. 다시 시도해 주세요.'
                        : '이메일을 입력해 주세요.';
                    this.alertRequiredShow = true;
                    return;
                }

                const fullEmail = `${emailId}@${emailDomain}`;
                if (!this.isValidEmail(fullEmail)) {
                    this.alertContent = '이메일 형식이 올바르지 않습니다.';
                    this.alertRequiredShow = true;
                    return;
                }

                const loginInfo = this.loginInfo;

                const encryptedEmail = encryptAES256(fullEmail);
                const encryptedMobile = encryptAES256(cleanMobile);
                const encryptedBirth = encryptAES256(userBirth);

                const requestData = {
                    "userEmail": encryptedEmail,
                    "userMobile": encryptedMobile,
                    "userBirth": encryptedBirth,
                    "userGender": this.genderValues || ''
                };

                if (!encryptedEmail) {
                    requestData.userEmail = fullEmail;
                }
                if (!encryptedMobile) {
                    requestData.userMobile = cleanMobile;
                }
                if (!encryptedBirth) {
                    requestData.userBirth = userBirth;
                }

                const response = await putAxios('bgm/v1/mem/member/' + loginInfo.userUuid, requestData);

                console.log("response", response);

                sessionStorage.setItem('termsChecked', false);
                sessionStorage.setItem('privacyChecked', false);
                sessionStorage.setItem('ecommChecked', false);
                sessionStorage.setItem('emailChecked', false);
                sessionStorage.setItem('smsChecked', false);

                this.alertContent = '변경이 완료 되었습니다.'
                this.alertRequiredShow = true;

            } catch (error) {
                console.error('정보 수정 중 오류가 발생했습니다:', error);

                if (error.status === 400) {
                    this.alertContent = '입력하신 정보를 확인해주세요.';
                } else if (error.status === 500) {
                    this.alertContent = '서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
                } else {
                    this.alertContent = '정보 수정 중 오류가 발생했습니다.';
                }
                this.alertRequiredShow = true;
            }
        },
    }
}
</script>

<style scoped>
.email_area_stacked {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
}

.email_input_row {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
}

.email_input_row :deep(.input_type1) {
    flex: 1;
    min-width: 0;
}

.email_at {
    flex-shrink: 0;
    font-size: 14px;
    color: #333;
}

.input_optional {
    color: #8f8f8f;
    font-size: 12px;
    font-weight: 500;
}

.mobile_notice {
    margin-top: 8px;
    font-size: 14px;
    color: #666;
    line-height: 1.4;
}

.required_star {
    color: #ff0000;
    font-weight: bold;
    margin-right: 2px;
}

.optional_info_panel {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    padding: 10px;
    border: 1px solid #ececec;
    border-radius: 8px;
    background-color: #ffffff;
    box-sizing: border-box;
}

.optional_info_item {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
}

.optional_info_item_gender {
    margin-top: 6px;
    padding-top: 12px;
    border-top: 1px solid #e5e5e5;
}

.optional_info_label {
    font-size: 12px;
    color: #555;
    font-weight: 600;
}

.optional_info_notice {
    font-size: 11px;
    color: #8a8a8a;
    margin-top: 13px;
}

.optional_info_notice_birth {
    display: block;
    margin-top: 0;
    line-height: 1.4;
}

.gender_select_area {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    width: 100%;
}

.gender_select_area :deep(.d_radio) {
    min-width: 0;
    width: 100%;
}

.gender_select_area :deep(.d_radio input) {
    display: none;
}

.gender_select_area :deep(.d_radio label) {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border: 1px solid #d8d8d8;
    border-radius: 8px;
    background-color: #f2f2f2;
    color: #9f9f9f;
    font-size: 16px;
    font-weight: 500;
    box-sizing: border-box;
}

.gender_select_area :deep(.d_radio input:checked + label) {
    background-color: #565656;
    border-color: #565656;
    color: #fff;
}

.login_input_list li :deep(#email1[disabled]),
.login_input_list li :deep(#email1[readonly]),
.login_input_list li :deep(#email2[disabled]),
.login_input_list li :deep(#email2[readonly]),
.login_input_list li :deep(#mobile[disabled]),
.login_input_list li :deep(#mobile[readonly]) {
    background-color: #f2f2f2 !important;
    -webkit-text-fill-color: #666 !important;
    color: #666 !important;
    opacity: 1 !important;
}

/* 이름, 생년월일, 성별 폰트 사이즈를 InputText와 동일하게 설정 */
.member_name_input_size {
    font-size: 16px !important;
    line-height: 24px !important;
    font-weight: 400 !important;
    color: #333 !important;
    text-indent: 0 !important;
    margin: 0 !important;
    padding: 12px 16px !important;
    border: 1px solid #ddd !important;
    border-radius: 4px !important;
    background-color: #f9f9f9 !important;
    min-height: 48px !important;
    box-sizing: border-box !important;
    display: flex !important;
    align-items: center !important;
}

/* MY PAGE 제목과 mypage_area 사이 마진 조정 */
.mypage_area {
    margin-top: 20px !important;
    /* 기존 60px → 20px */
    padding-top: 15px !important;
    /* 기존 32px → 15px */
}

/* PC와 모바일 구분 조정 */
@media (min-width: 1024px) {
    .mypage_area {
        margin-top: 5px !important;
        /* PC에서 25px */
        padding-top: 5px !important;
        /* PC에서 20px */
    }
}

@media (max-width: 1023px) {
    .mypage_area {
        margin-top: 5px !important;
        /* 모바일에서 15px */
        padding-top: 5px !important;
        /* 모바일에서 10px */
    }
}

/* PC 버전에서도 세로 배치 유지 */
@media (min-width: 1024px) {
    .email_area_stacked {
        max-width: none;
    }

    .email_input_row {
        justify-content: flex-start;
    }

    .member_name_input_size {
        font-size: 16px !important;
        min-height: 48px !important;
    }
}

/* 모바일 최적화 */
@media (max-width: 1023px) {
    .email_area_stacked {
        width: 100%;
        margin: 0 3px !important;
    }

    .email_input_row {
        width: calc(100% - 6px) !important;
        margin: 0 !important;
    }

    .email_input_row input {
        flex: 1;
        min-width: 0;
        margin: 0 !important;
    }

    .gender_select_area {
        gap: 6px;
    }

    .gender_select_area :deep(.d_radio label) {
        height: 34px;
        line-height: 34px;
        border-radius: 7px;
        font-size: 13px;
    }

    .optional_info_panel {
        gap: 8px;
        padding: 8px;
        border-radius: 8px;
    }

    .optional_info_item {
        gap: 4px;
    }

    .optional_info_item_gender {
        margin-top: 4px;
        padding-top: 10px;
    }

    .optional_info_label {
        font-size: 12px;
    }

    .optional_info_notice {
        font-size: 11px;
    }

    .mobile_notice {
        font-size: 12px;
        margin-top: 6px;
    }

    .member_name_input_size {
        font-size: 14px !important;
        min-height: 44px !important;
        padding: 10px 14px !important;
    }
}
</style>